import React from 'react'
import { Routes, Route } from 'react-router-dom'
import { ThemeProvider } from './components/ThemeContext'
import GlobalStyles from './components/GlobalStyles'

// Pages
import IndexPage from './pages/index'
import WorkIndexPage from './pages/work/index'
import BlogIndexPage from './pages/blog/index'
import BlogPost from './pages/blog/BlogPost'
import HurricanesAndDecisions from './pages/blog/HurricanesAndDecisions'
import ResumePage from './pages/work/resume'
import MegaTicPage from './pages/work/megatic'
import Hurricane from './pages/Hurricane'

function App() {
  return (
    <ThemeProvider>
      <GlobalStyles />
      <Routes>
        <Route path="/" element={<IndexPage />} />
        <Route path="/work" element={<WorkIndexPage />} />
        <Route path="/work/resume" element={<ResumePage />} />
        <Route path="/work/megatic" element={<MegaTicPage />} />
        <Route path="/blog" element={<BlogIndexPage />} />
        <Route path="/blog/hurricanes-and-decisions" element={<HurricanesAndDecisions />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/hurricane" element={<Hurricane />} />
      </Routes>
    </ThemeProvider>
  )
}

export default App